/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for usageType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="usageType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="automatic"/&gt; &lt;enumeration value="identifier"/&gt; &lt;enumeration value="fact"/&gt; &lt;enumeration value="attribute"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class UsageType extends Enum{

	enumValue = null;

	/**
	 * Specifies that the usage is not known.
	 */
	static  AUTOMATIC = UsageType.newLiteral("automatic");

	/**
	 * Specifies that the object is to be treated as an identifier.
	 */
	static  IDENTIFIER = UsageType.newLiteral("identifier");

	/**
	 * Specifies that the object is to be treated as a fact.
	 */
	static  FACT = UsageType.newLiteral("fact");

	/**
	 * Specifies that the object is to be treated as an attribute.
	 */
	static  ATTRIBUTE = UsageType.newLiteral("attribute");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < UsageType.values().length); ++i) {
			if (UsageType.values()[i].enumValue == v) {
				return UsageType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("UsageType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/UsageType.js